import type { Row as RowProps } from '@web/graphql-components'
import { PageComponent } from '../PageComponent'
import { Row as PageRow } from '@web/components/page-components/Row'

const Row = (props: RowProps) => <PageRow {...props} Component={PageComponent} />

export default Row
